// import Vue from 'vue';
// import moment from 'moment';
// import 'moment-timezone';

// Vue.filter('defaultDate', (value, format = 'DD/MM/YYYY HH:mm:ss', breakLine = false) => {
//     if (value) {
//         moment.locale('pt');

//         const parsedDate = moment.tz(value, 'America/Sao_Paulo');

//         if (format === 'fromNow') {
//             return parsedDate.fromNow();
//         }

//         if (breakLine) {
//             format = format.replace(' ', '[<br />]');
//         }

//         console.log('parsed date #1', parsedDate)
//         return parsedDate.format(format);
//     }
    
//     console.log('parsed date value #2 ', value)

//     return value;
// });

// TODO: SOLUÇÃO TEMPORÁRIA, REMOVER ASSIM QUE POSSÍVEL

import Vue from 'vue';
import moment from 'moment';

Vue.filter('defaultDate', (value, format = 'DD/MM/YYYY HH:mm:ss', breakLine = false) => {
    if (value) {
        moment.locale('pt');

        const adjustedDate = moment(value, 'YYYY-MM-DD HH:mm:ss').subtract(3, 'hours');

        if (format === 'fromNow') {
            return adjustedDate.fromNow();
        }

        if (breakLine) {
            format = format.replace(' ', '[<br />]');
        }

        return adjustedDate.format(format);
    }

    return value;
});